import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { HttpHook } from "../types/httpHook";

export const fetchHttpHookApi = async (config: {
  "hook-id": string;
  "app-id": string;
}): Promise<HttpHook> => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
(datastore Qo.Public.Api.HttpHook "omega/query-omega/public/api/http-hook")
(= Input ${ednString})
(Qo.Public.Api.HttpHook/get-http-hook Input Response)
(return [Response])
  `;
  return queryOmegaSingleResult(query);
};
